import { createHOC } from 'vue-hoc';

import ChangePasswordForm from './ChangePasswordForm';
import auth from '../../../../lib/common/providers/auth';
import userManagement from '../../../../lib/common/providers/userManagement';
import withUser from '../../../../lib/common/hoc/withUser';

const options = {
  name: 'ChangePasswordFormContainer',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      state: {
        processing: false,
        error: null,
        success: false,
      },
    };
  },
  async created() {
    if (!(await auth.isAuthenticated())) {
      this.$router.replace({ name: 'login' });
      return;
    }
  },
  methods: {
    getUser() {
      const { idTokenPayload } = JSON.parse(localStorage.getItem('vrpatients::auth::result'));
      return {
        ...idTokenPayload,
        id: idTokenPayload.sub,
        org: idTokenPayload['https://vrpatients.com/org'],
        permissions: [],
      };
    },
  }
};

const renderWith = {
  props: {
    processing() {
      return this.state.processing;
    },
    error() {
      return this.state.error;
    },
    success() {
      return this.state.success;
    }
  },
  listeners: {
    async changePassword(oldPassword, newPassword) {
      this.state.error = null;
      this.state.processing = true;
      try {
        this.state.processing = true;
        this.state.success = false;

        await userManagement.post('/account/change-password', {
          oldPassword,
          newPassword,
        });

        this.state.success = true;
      } catch (error) {
        this.state.error = { ...error, message: error.message || error.description || error.error_description || error };
      } finally {
        this.state.processing = false;
      }
    },
  },
};

const ChangePasswordFormContainer = withUser()(createHOC(
  ChangePasswordForm,
  options,
  renderWith,
));
export default ChangePasswordFormContainer;
